import type { FC } from "react";
import { SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";
import { Container, Title, Carousel } from "../../../shared/ui";
import { getRouteArticle } from "../../../shared/constants/routes";

import BlogCard, { BlogCardProps } from "../../../entities/Blog/ui/BlogCard/BlogCard";

import styles from "./ArticleCarousel.module.scss";

interface BlogsCarouselProps {
    data?: Array<BlogCardProps>;
}

export const ArticleCarousel: FC<BlogsCarouselProps> = ({ data }) => {
    const cards = data?.map((blog) => (
        <SwiperSlide key={blog.id} className={styles.slide}>
            <Link to={getRouteArticle(blog.id as string)}>
                <BlogCard {...blog} />
            </Link>
        </SwiperSlide>
    ));

    return (
        <div className={styles.wrapper}>
            <Container marginSize="standard" className={styles.companyInside}>
                <Title className={styles.title} level={3}>
                    Ещё новости о&nbsp;нас
                </Title>
                <Carousel
                    loop={false}
                    spaceBetween={20}
                    className={styles.carousel}
                    navigationTheme="light"
                    navigation="down"
                    classNameNavigation={styles.navigation}
                >
                    {cards}
                </Carousel>
            </Container>
        </div>
    );
};
